export type GraphMode = 'topology' | 'pathLookup';
